import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/functions'
import '@firebase/messaging'
//import { notification } from 'antd';
import quiteImpressed from './../audios/quite-impressed.ogg'

const firebaseConfig = {
    apiKey: 'AIzaSyBWZB1QSg4f8cAfEHl7TI8_C11DtVlSdAU',
    authDomain: 'gruposade.firebaseapp.com',
    databaseURL: 'https://gruposade.firebaseio.com',
    projectId: 'gruposade',
    storageBucket: 'gruposade.appspot.com',
    messagingSenderId: '729159686220',
    appId: '1:729159686220:web:1df5a3a4f881bf9342bce9'
}

const fire = firebase.initializeApp(firebaseConfig)

const db = firebase.database()
const firestore = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
let messaging
if (firebase.messaging.isSupported()) {
    messaging = firebase.messaging()
    messaging.onMessage(function (payload) {
        //openNotification(payload);
        playSound()
    })
}

// function openNotification(payload) {
//   const args = {
//     message: payload.data.title,
//     description: payload.data.body,
//     duration: 0,
//   };
//   notification.open(args);
// }

function playSound () {
    let audio = new Audio(quiteImpressed)
    audio.play()
}

// firebase.functions().useFunctionsEmulator('http://localhost:4000')
// console.error("<---------EMULADOR DE CLOUD FUNCTION ACTIVO--------->");

const cloudFunctions = {
    createUser: data => firebase.functions().httpsCallable('createUser')(data),
    deleteUser: data => firebase.functions().httpsCallable('deleteUser')(data),
    notifyTooManyRequest: data => firebase.functions().httpsCallable('notifyTooManyRequest')(data),
    tryAssignSurvey: data => firebase.functions().httpsCallable('tryAssignSurvey')(data),
    tryResolveSurvey: data => firebase.functions().httpsCallable('tryResolveSurvey')(data),
    requestNewChatMessage: data => firebase.functions().httpsCallable('requestNewChatMessage')(data),
    getServerTimestamp: data => firebase.functions().httpsCallable('getServerTimestamp')(data),
    requestNewChatImage: data => firebase.functions().httpsCallable('requestNewChatImage')(data),
    requestNewChatFile: data => firebase.functions().httpsCallable('requestNewChatFile')(data),
    newWorkOrder: data => firebase.functions().httpsCallable('newWorkOrder')(data),
    newBidOrder: data => firebase.functions().httpsCallable('newBidOrderV2')(data),
    getQuotationName: data => firebase.functions().httpsCallable('getQuotationName')(data),
    newOutsourcing: data => firebase.functions().httpsCallable('newOutsourcing')(data),
	sendEmails: data => firebase.functions().httpsCallable('sendEmails')(data),
	getBnaSellRate: data => firebase.functions().httpsCallable('getBnaSellRate')(data),
}

const admin = {}

export { db, firestore, auth, storage, admin, fire, cloudFunctions, messaging }
